import { Link } from "react-router-dom";
import { products } from "@/data/products";
import ProductGrid from "@/components/ProductGrid";

const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section className="hero" data-testid="hero-section">
        <div className="container-vzor hero-inner">
          <h1 className="hero-title">See better. Look sharper.</h1>
          <p className="hero-sub">Premium eyewear, delivered.</p>
          <Link
            to="/sunglasses"
            className="btn-accent"
            data-testid="hero-shop-sunglasses-btn"
            style={{ background: "#FFFFFF", color: "#0F766E" }}
          >
            Shop Sunglasses
          </Link>
        </div>
      </section>

      {/* Categories */}
      <section className="container-vzor" style={{ paddingTop: 56, paddingBottom: 24 }}>
        <h2 className="h-section" style={{ marginBottom: 20 }}>
          Shop by Category
        </h2>
        <div
          data-testid="category-tiles"
          style={{
            display: "grid",
            gap: 24,
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          }}
        >
          <Link to="/sunglasses" className="cat-tile" data-testid="cat-tile-sunglasses">
            <h3>Sunglasses</h3>
            <p>Polarized, UV-protected, and easy on the eyes.</p>
          </Link>
          <Link to="/eyeglasses" className="cat-tile" data-testid="cat-tile-eyeglasses">
            <h3>Eyeglasses</h3>
            <p>Blue-light and anti-glare for all-day comfort.</p>
          </Link>
        </div>
      </section>

      {/* Bestsellers */}
      <section className="container-vzor" style={{ paddingTop: 40, paddingBottom: 64 }}>
        <h2 className="h-section" style={{ marginBottom: 20 }}>
          Bestsellers
        </h2>
        <ProductGrid items={products} testId="bestsellers-grid" />
      </section>
    </div>
  );
};

export default Home;
